<template>
  <div class="tips">
    <div class="top">
      <div class="title">打开您的创维/酷开电视机，查看画面右上角</div>
      <div class="text">
        1、若显示为<span>GITV</span>，则您的电视为<span>爱奇艺影视源</span>，需购买<span>爱奇艺VIP卡</span>才可享用权益
      </div>
      <div class="img"><img src="@/assets/vip-buy/tips1.png" /></div>
      <div class="text">
        2、若显示为<span>NewTV</span>或<span>CCTV新视听</span>，则您的电视为<span>腾讯影视源</span>，需购买<span>腾讯VIP卡</span>才可享用权益
      </div>
      <div class="img"><img src="@/assets/vip-buy/tips2.png" /></div>
      <div class="text">
        2、若显示为<span>CIBN</span>或<span>华数</span>，则您的电视为<span>优酷影视源</span>，需购买<span>酷喵</span>才可享用权益
      </div>
      <div class="img"><img src="@/assets/vip-buy/tips3.png" /></div>
      <div class="buy-btn" @click="goBuy">检查无误，继续购买</div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data () {
    return {}
  },
  computed: {},
  methods: {
    goBuy () {
      this.$router.push({
        name: 'account-selection',
        query: {
          number: 1,
          goodsId: this.$route.query.goodsId,
          buyType: this.$route.query.buyType,
          appCode: this.$route.query.appCode,
          actCode: this.$route.query.actCode
        }
      })
    }
  },
  created () {}
}
</script>

<style lang="stylus" scoped>
.tips
  font-size 14px
  padding-bottom 30px
  width: 100%;
  background: #ececec;
  .top    
    margin 0 20px
  .title
    color #333333
    font-weight bold
    line-height 44px
  .img
    width 330px
    margin auto
    padding-bottom 30px
    img
      width 100%
  .text
    color #666666
    line-height 22px
    padding-bottom 16px
    span
      color #FD4E00
  .buy-btn
    height 44px
    line-height 44px
    border-radius 44px
    color #ffffff
    font-size 16px
    text-align center
    background #FC4C00
</style>
